var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.921,
    height: 48.576,
    viewBox: "0 0 31.921 48.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M42.452,50.576H17.47A3.474,3.474,0,0,1,14,47.106V5.47A3.474,3.474,0,0,1,17.47,2H42.452a3.474,3.474,0,0,1,3.47,3.47V47.106A3.474,3.474,0,0,1,42.452,50.576ZM17.47,3.388A2.082,2.082,0,0,0,15.388,5.47V47.106a2.082,2.082,0,0,0,2.082,2.082H42.452a2.082,2.082,0,0,0,2.082-2.082V5.47a2.082,2.082,0,0,0-2.082-2.082Z",
    transform: "translate(-14 -2)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M15,62H45.533v1.388H15Z",
    transform: "translate(-14.306 -20.363)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M33,66h5.552v1.388H33Z",
    transform: "translate(-19.815 -21.588)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M15,10H45.533v1.388H15Z",
    transform: "translate(-14.306 -4.448)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M31,6h8.327V7.388H31Z",
    transform: "translate(-19.203 -3.224)",
    fill: "#f2025d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.525c4eef05a91c4132768f4d0e18def5.svg";
export { ForwardRef as ReactComponent };